import { profileState } from "@/atoms/user/profile-state";
import { Radio } from "flowbite-react";
import { useRecoilValue } from "recoil";

const PayLaterConfirm = ({
  setIsPayLaterConfirmed,
}: {
  setIsPayLaterConfirmed: (v: boolean) => void;
}) => {
  const profile = useRecoilValue(profileState);
  return (
    <div className="h-[284px] pb-4 flex-col justify-start items-center gap-3 inline-flex">
      <div className="self-stretch h-[234px] px-6 py-4 bg-white rounded-lg flex-col justify-start items-center gap-4 flex">
        <div className="flex-col justify-start items-center gap-1 flex">
          <div className="w-5 h-5 relative overflow-hidden" />
          <div className="text-[#e80a4d] text-base font-semibold font-['Pretendard'] leading-normal">
            후불결제는 익월 입금을 허용합니다.
          </div>
          <div className="text-[#e80a4d] text-sm font-normal font-['Pretendard'] leading-snug">
            입금기한 내 입금되지 않는 경우 패널티 부과됩니다.
          </div>
        </div>
        <div className="flex-col justify-start items-start gap-2 flex">
          <div className="justify-center items-start gap-4 inline-flex">
            <div className="w-[116px] text-[#18273a]/95 text-sm font-bold font-['Pretendard'] leading-snug">
              세금계산서 발행시기
            </div>
            <div className="text-center text-[#18273a]/95 text-sm font-normal font-['Pretendard'] leading-snug">
              익월 5영업일 내
            </div>
          </div>
          <div className="justify-center items-start gap-4 inline-flex">
            <div className="text-center text-[#18273a]/95 text-sm font-bold font-['Pretendard'] leading-snug">
              세금계산서 발행기준
            </div>
            <div className="text-center text-[#18273a]/95 text-sm font-normal font-['Pretendard'] leading-snug">
              당월 말일자/대금 합산 발행
            </div>
          </div>
          <div className="justify-center items-start gap-4 inline-flex">
            <div className="w-[116px] text-[#18273a]/95 text-sm font-bold font-['Pretendard'] leading-snug">
              입금 기한
            </div>
            <div className="text-center text-[#18273a]/95 text-sm font-normal font-['Pretendard'] leading-snug">
              익월 말일
            </div>
          </div>
          <div className="justify-center items-start gap-4 inline-flex">
            <div className="w-[116px] text-[#18273a]/95 text-sm font-bold font-['Pretendard'] leading-snug">
              세금계산서 발송
            </div>
            <div className="text-center text-[#616d7c] text-sm font-medium font-['Pretendard'] leading-snug">
              {profile.email}
            </div>
          </div>
        </div>
      </div>
      <div className="rounded-lg justify-start items-start gap-2 inline-flex">
        <div className="flex items-center gap-2">
          <Radio
            id="payLaterConfirm"
            onChange={(e) => setIsPayLaterConfirmed(e.target.checked)}
          />
          <div className="text-[#192434] text-sm font-medium font-['Pretendard'] leading-snug">
            내용 확인했습니다.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayLaterConfirm;
